import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

const useResourcesForm = ({
  urlSearchParams,
  lockParamString,
  noResultQuery,
  setPagesToShow,
  setPrefetchedPages,
}) => {
  const schema = {
    type: z.union([z.number(), z.string()]).optional(),
    industry: z.union([z.number(), z.string()]).optional(),
    keywords: z.string().optional(),
  }

  const defaultValues = {
    type: urlSearchParams?.get('type')
      ? Number(urlSearchParams.get('type'))
      : 1,
    industry: urlSearchParams?.get('industry')
      ? Number(urlSearchParams.get('industry'))
      : undefined,
    keywords: urlSearchParams?.get('keywords') || '',
  }

  const form = useForm({
    resolver: zodResolver(z.object(schema)),
    defaultValues,
  })

  const onSubmit = async () => {
    lockParamString()
    setPagesToShow(1)
    setPrefetchedPages(false)
  }

  return {
    form,
    onSubmit,
    noResultQuery,
  }
}

export default useResourcesForm
